export class Page<T> {
  static fromJson<T>(json: any, items: T[]): Page<T> {
    return new Page({
      page: json.page,
      pageCount: json.page_count,
      pageSize: json.page_size,
      totalSize: json.total_size,
      items
    });
  }

  public readonly page: number;
  public readonly pageCount: number;
  public readonly pageSize: number;
  public readonly totalSize: number;

  public readonly items: T[];

  constructor({ page, pageCount, pageSize, totalSize, items }: Page<T>) {
    this.page = page;
    this.pageCount = pageCount;
    this.pageSize = pageSize;
    this.totalSize = totalSize;
    this.items = items;
  }
}
